import TableContainer from "components/tables/TableContainer"
import React, { useMemo } from "react"
import { useSelector } from "react-redux"

const TableJacket = ({ content }) => {
  const store = useSelector(state => state)
  const data = store.productionSummary.list.data?.jackets || []
  const columns = useMemo(
    () => [
      {
        Header: "上着",
        columns: [
          {
            Header: "製作者名",
            accessor: "creator_name",
          },
        ],
      },
      {
        Header: "Bespoke",
        columns: [
          {
            Header: "制作数",
            accessor: "production_number_bespoke",
          },
          {
            Header: "制作高",
            accessor: "production_amount_bespoke",
          },
        ],
      },
      {
        Header: "MTM",
        columns: [
          {
            Header: "制作数",
            accessor: "production_number_mtm",
          },
          {
            Header: "制作高",
            accessor: "production_amount_mtm",
          },
        ],
      },
      {
        Header: "RTW",
        columns: [
          {
            Header: "制作数",
            accessor: "production_number_rtw",
          },
          {
            Header: "制作高",
            accessor: "production_amount_rtw",
          },
        ],
      },
      {
        Header: "お直し",
        columns: [
          {
            Header: "制作数",
            accessor: "production_number_repair",
          },
          {
            Header: "制作高",
            accessor: "production_amount_repair",
          },
        ],
      },
      {
        Header: "サンプル",
        columns: [
          {
            Header: "制作数",
            accessor: "production_number_sample",
          },
          {
            Header: "制作高",
            accessor: "production_amount_sample",
          },
        ],
      },
      {
        Header: "合計",
        columns: [
          {
            Header: "制作数",
            accessor: "production_number_total",
          },
          {
            Header: "制作高",
            accessor: "production_amount_total",
          },
        ],
      },
    ],
    []
  )

  const listDataTable = useMemo(() => {
    if (!data) return []
    return data.map((v, i) => ({
      creator_name: v.staffName,
      production_number_bespoke: v.bespoke.number,
      production_amount_bespoke: v?.bespoke?.amount.toLocaleString("ja-JP"),
      production_number_mtm: v.mtm.number,
      production_amount_mtm: v?.mtm?.amount.toLocaleString("ja-JP"),
      production_number_rtw: v.rtw.number,
      production_amount_rtw: v?.rtw?.amount.toLocaleString("ja-JP"),
      production_number_repair: v.repair.number,
      production_amount_repair: v?.repair?.amount.toLocaleString("ja-JP"),
      production_number_sample: v.sample.number,
      production_amount_sample: v?.sample?.amount.toLocaleString("ja-JP"),
      production_number_total: v.bespoke.number + v.mtm.number +  v.rtw.number + v.repair.number + v.sample.number,
      production_amount_total: (v.bespoke.amount + v.mtm.amount +  v.rtw.amount + v.repair.amount + v.sample.amount).toLocaleString("ja-JP"),
      
    }))
  }, [data])

  if (data.length < 1) {
    return <></>
  }

  return (
    <TableContainer columns={columns} data={listDataTable} pagination={false} />
  )
}

export default TableJacket
